import { render, staticRenderFns } from "./ListLives.vue?vue&type=template&id=d1a15ee0&"
import script from "./ListLives.vue?vue&type=script&lang=js&"
export * from "./ListLives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports